export function setUpdatedData(data, newData, type, isStatus) {

    let updatedData = [];

    switch (type) {
        case "edit":
            swal("", `${isStatus || ""}updated successfully!`, "success")
            updatedData = data.map(item => ((item.id === newData.id) ? newData : item));
            break;
        case "add":
            swal("", "added successfully!", "success")
            updatedData = [...data, newData];
            break;
        case "delete":
            swal("", "deleted successfully!", "success")
            updatedData = data.filter(item => (item.id !== newData.id));
            break;

        default: updatedData = data
    }

    return updatedData
}